import { SearchWordListAttribute } from '../../types/SearchWordListAttribute';
import { FiChevronRightIcon } from '../Icon';
import { RankingIcon } from '../Icon/RankingIcon';

import styles from './SearchWordList.module.scss';

import type { FC } from 'react';

type Props = {
  attributes: SearchWordListAttribute[];
  type: 'default' | 'ranking';
};

export const SearchWordList: FC<Props> = ({ attributes, type }) => (
  <div className={styles['list-box']}>
    {attributes.map((SearchWordListProps) => (
      <a
        className={styles.wrap}
        key={SearchWordListProps.id}
        href={SearchWordListProps.url}
      >
        <span className={styles['text-block']}>
          {type === 'ranking' ? (
            <RankingIcon rankingNumber={SearchWordListProps.id} />
          ) : (
            ''
          )}
          <span className={styles.text}>{SearchWordListProps.title}</span>
          {SearchWordListProps.count ? (
            <span className={styles.count}>({SearchWordListProps.count})</span>
          ) : (
            ''
          )}
        </span>
        <FiChevronRightIcon size={18} />
      </a>
    ))}
  </div>
);
